import { routes } from "../common/routes";
import api from "./axios";

export const getEmployerContent = async (id) => {
    const params = { v: process.env.REACT_APP_VERSION, id: Number(id) };
    const response = await api.get(routes.employer.employerProfile, { params });
    return response.data;
}
